import { render } from "./NewTreinoView.vue?vue&type=template&id=bff1c16a"
import script from "./NewTreinoView.vue?vue&type=script&lang=js"
export * from "./NewTreinoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__